import { Outlet } from 'react-router-dom';
import { PrelineLoader } from './PrelineLoader';
import { ErrorBoundary } from '../components/ErrorBoundary';

/**
 * Auth Layout for login/authentication routes
 *
 * Provides:
 * - Preline UI initialization
 * - Error boundary for auth pages
 * - Clean wrapper for authentication pages
 */
export function AuthLayout() {
  return (
    <>
      <PrelineLoader />
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </>
  );
}
